<template>
    <vs-popup classContent="popup-example"  title="ویرایش مقاله" :active.sync="showPopup">
        <!-- <form class="p-4" @keydown.enter="editArticleInfo()"> -->
        <form class="px-4">
            <div class="vx-row px-5 mb-4">
                <div class="vx-col w-2/5">
                    <label class="vs-input--label">عنوان</label>
                    <vs-input class="w-full" v-model="title" />
                </div>
                <div class="vx-col w-2/5 upload-btn-wrapper">
                    <label class="vs-input--label">آپلود عکس</label>
                    <b-form-file
                        v-model="file"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        accept="image/*"
                    />
                    <!-- <input type="file" id="file" ref="file"  @change="uploadImg()" /> -->
                </div>
                <div class="vx-col w-1/5">
                    <img v-if="srcFile" :src="srcFile" style="width: 100%;height:auto;">
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">توضیحات</label>
                    <quill-editor v-model="text"></quill-editor>
                    <!-- <vs-textarea v-model="text" rows="4" /> -->
                </div>
            </div>

            <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-col class="sm:w-1/2 w-full">
                    
                </vs-col>
                <vs-col class="sm:w-1/2 w-full">
                    <vs-button class="mr-3 float-right" @click="editArticleInfo()">ثبت</vs-button>
                </vs-col>
            </vs-row>
        </form>
    </vs-popup>
</template>

<script>
import { BFormFile } from 'bootstrap-vue'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    name: 'EditArticle',

    props: {
        popupEditArticle: {
            type: Boolean,
            default: false,
        },
        articleId: Number
    },
    
    components: {
        BFormFile,
        quillEditor
    },
    
    data() {
		return{
            showPopup: false,
            file: [],
            title: '',
            thumbnail: '',
            text: '',
            srcFile: '',

            editorOption: {
                modules: {
                    toolbar: '#toolbar2'
                }
            }
		}
    },
    
    computed: {
    },

    watch: {
      	popupEditArticle: function(newVal) {
            this.showPopup = newVal
            this.srcFile = ''
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getPostInfo', this.articleId)
                .then(res => {
                    localStorage.setItem('postId', this.articleId)
                    this.title = res.data[0].title
                    this.thumbnail = res.data[0].thumbnail
                    this.text = res.data[0].text
                    if(this.thumbnail != null){
                        this.srcFile = 'https://appapi.akambc.com/' + this.thumbnail
                    }
                    this.$vs.loading.close()
                }).catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditArticle', newVal)
            this.title = ''
            this.thumbnail = ''
            this.text = ''
        },
    },

    created(){	
    },
    
    methods: {
        uploadImg() {
            this.file = this.$refs.file.files[0];
        },

        editArticleInfo(){
			this.$vs.loading()
            this.$emit('updatePopupEditArticle', false)
            let formData = new FormData();
            formData.append('thumbnail', this.file);
            formData.append('title', this.title);
            formData.append('text', this.text);
            formData.append('id', this.id);
            formData.append('type', 'article');

            formData.append('order', 0);
            

            // let id = this.articleId
            
            this.$store.dispatch('updatePostInfo', formData)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'مقاله با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
		},
    }
}
</script>